
export class RoleContactId {
    roleContactId: number;

    /**
     * 
     * @param roleContactId 
     */
    constructor(roleContactId: number) {
        this.roleContactId = roleContactId;
    }
}